import { render, staticRenderFns } from "./proccessStatistics.vue?vue&type=template&id=3a2ec067"
import script from "./proccessStatistics.vue?vue&type=script&lang=js"
export * from "./proccessStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports